import { jsx as n, jsxs as t } from "react/jsx-runtime";
import { Children as k, isValidElement as x, cloneElement as C } from "react";
import { callAll as h } from "../../utils/utils.js";
import { ErrorText as E } from "../ErrorText/ErrorText.js";
import { FormGroup as T } from "../FormGroup/FormGroup.js";
import { HintText as g } from "../HintText/HintText.js";
import { LabelText as j } from "../LabelText/LabelText.js";
import { Legend as F } from "../Legend/Legend.js";
const z = ({
  name: s,
  label: d,
  hint: l,
  error: e,
  children: u,
  optional: f = !1,
  defaultValue: p,
  value: a,
  onValueChange: i,
  "aria-invalid": m,
  ...c
}) => {
  const o = !!e;
  return /* @__PURE__ */ n(T, { "data-error": o || void 0, children: /* @__PURE__ */ t("fieldset", { "aria-invalid": m ?? (o ? !0 : void 0), ...c, children: [
    /* @__PURE__ */ t(F, { children: [
      /* @__PURE__ */ t(j, { children: [
        d,
        f ? " (optional)" : null
      ] }),
      l ? /* @__PURE__ */ n(g, { children: l }) : null,
      e ? /* @__PURE__ */ n(E, { children: e }) : null
    ] }),
    k.map(
      u,
      (r) => x(r) ? C(r, {
        "data-error": o ? !0 : r.props["data-error"],
        name: r.props.name || s,
        defaultChecked: r.props.defaultChecked != null ? r.props.defaultChecked : p && (p === r.props.value ? !0 : void 0),
        checked: r.props.checked != null ? r.props.checked : a && a === r.props.value,
        onChange: h(
          i && ((v) => i(v.currentTarget.value)),
          r.props.onChange
        )
      }) : null
    )
  ] }) });
};
export {
  z as RadioField
};
